var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMeasurementjobsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4V26H6.44444V6.55814L4 4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 26L4 4L5.22222 8.60465L22.3333 26H26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3889 26H4V23.9535H21.7222L25.3889 26Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.5V23H9V16L7.5 12.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23L7.5 12.5L9 16L16 23H18Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7222 23H7.5L9 21.5H14.5L17.7222 23Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasurementjobsIcon);
export default __webpack_public_path__ + "static/media/MeasurementjobsIcon.fe8248d5.svg";
export { ForwardRef as ReactComponent };